import { formatDistanceToNowStrict, format, parseISO } from 'date-fns';

/**
 * Kosh money is stored as INTEGER MINOR UNITS (paise/cents). Format to a
 * currency string, dividing by 100. `currency` is an ISO 4217 code (INR, USD…).
 */
export function formatMoney(
  minorUnits: number | null | undefined,
  currency = 'INR',
): string {
  const value = (minorUnits ?? 0) / 100;
  try {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency,
      maximumFractionDigits: 2,
    }).format(value);
  } catch {
    // Unknown currency code — fall back to a plain number with the raw code.
    return `${currency} ${value.toLocaleString('en-IN', { maximumFractionDigits: 2 })}`;
  }
}

/** Percentage from a 0–1 ratio (e.g. collectionRate). */
export function formatPercent(ratio: number | null | undefined): string {
  if (ratio == null || Number.isNaN(ratio)) return '—';
  return `${Math.round(ratio * 100)}%`;
}

export function relativeTime(iso: string | undefined | null): string {
  if (!iso) return '—';
  try {
    return `${formatDistanceToNowStrict(parseISO(iso))} ago`;
  } catch {
    return iso;
  }
}

export function shortDateTime(iso: string | undefined | null): string {
  if (!iso) return '—';
  try {
    return format(parseISO(iso), 'd MMM, h:mm a');
  } catch {
    return iso;
  }
}

export function shortDate(iso: string | undefined | null): string {
  if (!iso) return '—';
  try {
    return format(parseISO(iso), 'd MMM yyyy');
  } catch {
    return iso;
  }
}
